import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getTranslatedSkills = api(async function getTranslatedSkills({ language }) {
    return query(
        gql`
            query GetTranslatedSkills($language: String!) {
                getTranslatedSkills(language: $language)
            }
        `,
        { language },
        { returns: "getTranslatedSkills" }
    )
})
